import { render, staticRenderFns } from "./SwitchLang.vue?vue&type=template&id=7b612b31&"
import script from "./SwitchLang.vue?vue&type=script&lang=js&"
export * from "./SwitchLang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports